export class DomUtils {
    public static generateElementId(length: number = 5): string {
        const alphabet = '0123456789abcdefghiklmnopqrstuvwxyz'.split('');

        let str = '';
        for (let i = 0; i < length; i++) {
            str += alphabet[Math.floor(Math.random() * alphabet.length)];
        }
        return `tfb-${str}`;
    }

    /**
     * Generate a unique ID for the current document.
     * @param blackList
     * IDs that cannot be generated.
     * @param length
     * Initial length of the generated ID.
     * @param sameLengthAttempts
     * Maximum number of attempts to generate a new ID, after which, if a unique ID has not yet been generated,
     * the length of the generated ID will be increased by 1 character.
     */
    public static generateUniqueElementId(blackList: string[], length: number = 5, sameLengthAttempts: number = 100): string {
        let id = DomUtils.generateElementId(length);

        let generationAttemptCounter = 0;
        const sameLengthMaxNumberGenerationAttempts = blackList.length + sameLengthAttempts;

        while (document.getElementById(id) || blackList.includes(id)) {
            id = DomUtils.generateElementId(length);

            if (generationAttemptCounter > sameLengthMaxNumberGenerationAttempts) {
                length += 1;
                generationAttemptCounter = 0;
                continue;
            }

            generationAttemptCounter++;
        }

        return id;
    }

    public static deleteAllChildElements(domNode: HTMLElement): void {
        while (domNode.firstChild) {
            domNode.removeChild(domNode.firstChild);
        }
    }
}
